/**
 *  Game Ids - Have different restrictions.
 */
export enum GameId {
  ActionGame = 'AG',
  Terraforming = 'TF',
  ComingSoon = 'CS'
}

export enum GameModes {
  OutpostRun = 'OR',
  ZoneRush = 'ZR',
  Terraforming = 'TF'
}
